<div class="w-full space-y-2">
    @for (row of getRowsArray(); track row) {
    <div class="flex flex-row items-center w-full py-4 border-b">
        @for (column of columns; track $index) {
        <div [class]="column.className || 'pr-4'" [style.width]="column.width">
            <ngx-skeleton-loader [count]="1" [appearance]="column.appearance || 'line'" [theme]="getTheme(column)">
            </ngx-skeleton-loader>
        </div>
        }
    </div>
    }
</div>